import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Carousel from '../../components/Carousel/Carousel';
import Footer from '../../components/Footer/Footer';
import Video from '../../components/Video/Video';
import SellingPoints from '../../components/SellingPoints/SellingPoints';
import WelcomeSection from '../../components/WelcomeSection/WelcomeSection';
import AngleDivider from '../../components/AngleDivider/AngleDivider';
import BrandShowcase from '../../components/BrandShowcase/BrandShowcase';

import './HomePage.css';
import '../../resources/styling/GlobalStyles.css';


// Single Video
import factoryVideo1 from '../../resources/assets/videos/KozeeVideo.mp4';


const Homepage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div className="page-container">
      <main className="main-content">

        <div className="section bg-light" data-aos="fade-up">
          <WelcomeSection />
        </div>

        <AngleDivider variant="peak" color="#ffffff" flip />

        <div className="section bg-light" data-aos="fade-right">
          <Video videoSrc={factoryVideo1} reverse={false} />
        </div>

        <div className="section bg-light" data-aos="fade-up" data-aos-delay="100">
          <SellingPoints />
        </div>

        <AngleDivider variant="wave" color="#ffffff" />

        <div className="section bg-light" data-aos="fade-up" data-aos-delay="200">
          <BrandShowcase />
        </div>

      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Homepage;
